export const GET_ANIMALS = "GET_ANIMALS";
export const UPDATE_ANIMAL = "UPDATE_ANIMAL";
export const DELETE_ANIMAL = "DELETE_ANIMAL";
export const ANIMAL_ERROR = "ANIMAL_ERROR";
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
